module.exports = __webpack_public_path__ + "b2026879.svg";